<details #details>
  <summary
    #summary
    [attr.aria-controls]="id() + '-content'"
    aria-expanded="false"
    [id]="id() + '-header'"
    (click)="toggleAccordion($event)"
  >
    <opac-icon *ngIf="iconPosition === 'start'" class="marker-icon start" [icon]="iconName()"></opac-icon>

    <div class="content-wrapper">
      <span>
        {{ title }}
      </span>

      <ng-content select="[slot='end']"></ng-content>
    </div>

    <opac-icon *ngIf="iconPosition === 'end'" class="marker-icon end" [icon]="iconName()"></opac-icon>
  </summary>

  <div
    #content
    [attr.aria-labelledby]="id() + '-header'"
    class="content"
    [id]="id() + '-content'"
    role="region"
  >
    <ng-content></ng-content>
  </div>
</details>
